var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"card"},[_c('div',{staticStyle:{"width":"550px","height":"550px"},attrs:{"id":"main"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }